// You can rearrange the weekdays and months, but do not change the "number" attribute

const WEEKDAYS = formatMessage => [
  {
    shortLabel: formatMessage({ id: 'SUN', defaultMessage: 'Sun' }),
    longLabel: formatMessage({ id: 'SUNDAY', defaultMessage: 'Sunday' }),
    value: 'SUNDAY',
    number: 1,
  },
  {
    shortLabel: formatMessage({ id: 'MON', defaultMessage: 'Mon' }),
    longLabel: formatMessage({ id: 'MONDAY', defaultMessage: 'Monday' }),
    value: 'MONDAY',
    number: 2,
  },
  {
    shortLabel: formatMessage({ id: 'TUE', defaultMessage: 'Tue' }),
    longLabel: formatMessage({ id: 'TUESDAY', defaultMessage: 'Tuesday' }),
    value: 'TUESDAY',
    number: 3,
  },
  {
    shortLabel: formatMessage({ id: 'WED', defaultMessage: 'Wed' }),
    longLabel: formatMessage({ id: 'WEDNESDAY', defaultMessage: 'Wednesday' }),
    value: 'WEDNESDAY',
    number: 4,
  },
  {
    shortLabel: formatMessage({ id: 'THU', defaultMessage: 'Thu' }),
    longLabel: formatMessage({ id: 'THURSDAY', defaultMessage: 'Thursday' }),
    value: 'THURSDAY',
    number: 5,
  },
  {
    shortLabel: formatMessage({ id: 'FRI', defaultMessage: 'Fri' }),
    longLabel: formatMessage({ id: 'FRIDAY', defaultMessage: 'Friday' }),
    value: 'FRIDAY',
    number: 6,
  },
  {
    shortLabel: formatMessage({ id: 'SAT', defaultMessage: 'Sat' }),
    longLabel: formatMessage({ id: 'SATURDAY', defaultMessage: 'Saturday' }),
    value: 'SATURDAY',
    number: 7,
  },
];

const MONTHS = formatMessage => [
  {
    shortLabel: formatMessage({ id: 'JAN', defaultMessage: 'Jan' }),
    longLabel: formatMessage({ id: 'JANUARY', defaultMessage: 'January' }),
    value: 'JANUARY',
    number: 1,
  },
  {
    shortLabel: formatMessage({ id: 'FEB', defaultMessage: 'Feb' }),
    longLabel: formatMessage({ id: 'FEBRUARY', defaultMessage: 'February' }),
    value: 'FEBRUARY',
    number: 2,
  },
  {
    shortLabel: formatMessage({ id: 'MAR', defaultMessage: 'Mar' }),
    longLabel: formatMessage({ id: 'MARCH', defaultMessage: 'March' }),
    value: 'MARCH',
    number: 3,
  },
  {
    shortLabel: formatMessage({ id: 'APR', defaultMessage: 'Apr' }),
    longLabel: formatMessage({ id: 'APRIL', defaultMessage: 'April' }),
    value: 'APRIL',
    number: 4,
  },
  {
    shortLabel: formatMessage({ id: 'MAY', defaultMessage: 'May' }),
    longLabel: formatMessage({ id: 'MAY', defaultMessage: 'May' }),
    value: 'MAY',
    number: 5,
  },
  {
    shortLabel: formatMessage({ id: 'JUN', defaultMessage: 'Jun' }),
    longLabel: formatMessage({ id: 'JUNE', defaultMessage: 'June' }),
    value: 'JUNE',
    number: 6,
  },
  {
    shortLabel: formatMessage({ id: 'JUL', defaultMessage: 'Jul' }),
    longLabel: formatMessage({ id: 'JULY', defaultMessage: 'July' }),
    value: 'JULY',
    number: 7,
  },
  {
    shortLabel: formatMessage({ id: 'AUG', defaultMessage: 'Aug' }),
    longLabel: formatMessage({ id: 'AUGUST', defaultMessage: 'August' }),
    value: 'AUGUST',
    number: 8,
  },
  {
    shortLabel: formatMessage({ id: 'SEP', defaultMessage: 'Sep' }),
    longLabel: formatMessage({ id: 'SEPTEMBER', defaultMessage: 'September' }),
    value: 'SEPTEMBER',
    number: 9,
  },
  {
    shortLabel: formatMessage({ id: 'OCT', defaultMessage: 'Oct' }),
    longLabel: formatMessage({ id: 'OCTOBER', defaultMessage: 'October' }),
    value: 'OCTOBER',
    number: 10,
  },
  {
    shortLabel: formatMessage({ id: 'NOV', defaultMessage: 'Nov' }),
    longLabel: formatMessage({ id: 'NOVEMBER', defaultMessage: 'November' }),
    value: 'NOVEMBER',
    number: 11,
  },
  {
    shortLabel: formatMessage({ id: 'DEC', defaultMessage: 'Dec' }),
    longLabel: formatMessage({ id: 'DECEMBER', defaultMessage: 'December' }),
    value: 'DECEMBER',
    number: 12,
  },
];

const getWeekdays = formatMessage => {
  return WEEKDAYS(formatMessage);
};

const getWeekday = ({ formatMessage, weekDay, number }) => {
  if (weekDay) {
    return WEEKDAYS(formatMessage).find(w => w.value === weekDay);
  }
  if (number) {
    return WEEKDAYS(formatMessage).find(w => w.number === number);
  }
  return null;
};

const getMonths = formatMessage => {
  return MONTHS(formatMessage);
};

const getMonth = ({ formatMessage, month, number }) => {
  if (month) {
    return MONTHS(formatMessage).find(w => w.value === month);
  }
  if (number) {
    return MONTHS(formatMessage).find(w => w.number === number);
  }
  return null;
};

export { WEEKDAYS, MONTHS, getWeekdays, getMonths, getWeekday, getMonth };
